import List from './list/ReferralRecipientListInitialState'

const { Record } = require('immutable')

export default Record({
    list: List()
})